import React, { Component } from 'react'
import PropTypes from 'prop-types'
import theme, {whiteLabelData}  from '../../theme'

import log from 'loglevel'
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import i18next, {t} from 'i18next';

// Application Components
import toast from "../../../utils/ToasterService";

// Material components

import { Paper, Grid, TextField, Button, Typography, Select, Container } from '@mui/material'


const styles = {
    root: {
        //padding: theme.spacing(4),
        maxWidth: 420,
        boxSizing: 'border-box',
        width: '100%',
        padding:40
    },
    buttonContainer: {
        marginTop: 20,
    },
    textField: {
      minWidth: 'inherit',
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    registrationLanguageSelect: {
        ' -moz-appearance': 'none',
          '-webkit-appearance': 'none',
         'appearance': 'none',
         'border': 'none',
         'width': '100%',
         'outline': 'none',
    },
    selectLang: {
      fontSize: 12,
    }
}

class Registration extends Component {
    state = {
        emailError: this.props.emailError,
        success: this.props.success,
        pwError: false,
        mailError: false,
        inputs: {
            forename: '',
            surname: '',
            telephone: '',
            email: '',
            password: '',
            repeatPassword: '',
        },
        regexEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        language: i18next.language
    }

    static propTypes = {
        classes: PropTypes.objectOf(PropTypes.string).isRequired,
        emailError: PropTypes.bool,
        passwordError: PropTypes.bool,
        repeatPassword: PropTypes.bool,
        success: PropTypes.bool,
        onRegisterUser: PropTypes.func.isRequired
    }

    static defaultProps = {
        emailError: false,
        passwordError: false,
        repeatPassword: false,
        success: false,
    }

    handleChangeInput = (key, value) => {
        const { inputs } = this.state;
        inputs[key] = value;
        this.setState({inputs, errorMsg: ''});
    };

    handleSubmit = () => {
        const { inputs: {forename, surname, telephone, email, password }} = this.state;
        const language = i18next.language;
        if(this.inputsValid()) {
            const data = {
                forename,
                surname,
                telephone,
                email,
                password,
                language
            };

            this.props.onRegisterUser(data,
                () => {
                    toast.success(t('Registration.toast_success'));
                    this.setState({success: true})
                },
                (error) => {
                    toast.error(error.msg);
                    log.error('Couldnt register: ', error)
                })
        } else {
          toast.error(t('Registration.toast_error'));
        }
    }

    handleSubmitEnter = e => {
        if ('Enter' === e.key) {
            this.handleSubmit()
        }
    };

    forenameValid = () => {
        const { inputs: {forename} } = this.state;
        return forename.trim().length > 0;
    };

    surnameValid = () => {
        const { inputs: {surname} } = this.state;
        return surname.trim().length > 0;
    };

    emailValid = () => {
        const { inputs: {email}, regexEmail } = this.state;

        return email.trim().length > 0 ? regexEmail.test(email.toLowerCase()) : true ;
    };

    inputsValid = () => {
        const { inputs: {password, repeatPassword, email}, regexEmail } = this.state;
        let result = true;

        if (regexEmail.test(email.toLowerCase())) {
          this.setState({mailError: false})
        } else {
          this.setState({mailError: true})
          result = false;
        }

        if (password.trim().length > 11 && repeatPassword.trim().length > 11 && password === repeatPassword) {
          this.setState({pwError: false})
        } else {
          this.setState({pwError: true})
          result = false;
        }

        return result;
    };

    backToLogin = () => {
        this.props.router.push('/login')
    };

    handleLanguageChange = (event) => {
        i18next.changeLanguage(event.target.value)
        this.setState({language: event.target.value})
    }

    render () {
        const { classes } = this.props;
        const { inputs: { email, password, repeatPassword }, pwError, mailError } = this.state;

        const passwordError = (password.trim().length > 0 && repeatPassword.trim().length > 0) && (password !== repeatPassword || password.length < 12 );
        const repeatPasswordError = ((password !== repeatPassword) && repeatPassword.length > 0);
        const passwordHelperText = passwordError ? t('Registration.helpertext_error_password') : '';
        const repeatPWHelperText = repeatPasswordError ? t('Registration.helpertext_error_password') : '';

        return (
            <Container  component="main" maxWidth="md">
                <Grid container justifyContent="center">
                    <Grid item style={{ marginBottom: 50, marginTop:50 }}>
                        <img style={{ width: '100%', maxWidth: '300px' }} src={whiteLabelData.logo} alt="" />
                    </Grid>
                </Grid>
                <Grid container justifyContent="center">
                    <Paper sx={{padding: 5, width: '100%', maxWidth: 420}}>
                        <Grid container direction="column" justify="center" alignItems="center">
                            <Typography style={{ fontSize: 20 }}>
                              {whiteLabelData.name}
                            </Typography>
                            <Typography style={{ fontSize: 16}}>
                              <Trans i18nKey="Registration.title"/>
                            </Typography>
                            {!this.state.success && (
                                <div>
                                    <Grid container justifyContent="center" alignItems="center">
                                        <TextField
                                        InputProps={{
                                                classes: {
                                                    underline: styles.textFieldUnerline
                                                },
                                            }}
                                            InputLabelProps={{
                                                FormLabelClasses: {
                                                    root: styles.textFieldFormLabel,
                                                    focused: styles.textFieldFocused,
                                                },
                                            }}
                                            label={t('Global.title_email')}
                                            name="email"
                                            value={ email }
                                            margin="normal"
                                            type={'email'}
                                            style={styles.textField}
                                            fullWidth={true}
                                            required
                                            error={mailError}
                                            helperText={!this.emailValid() ? t('Registration.helpertext_error_email') : ''}
                                            onChange={ e => this.handleChangeInput(e.target.name, e.target.value) }
                                        />
                                        <TextField
                                        InputProps={{
                                                classes: {
                                                    underline: styles.textFieldUnerline
                                                },
                                            }}
                                            InputLabelProps={{
                                                FormLabelClasses: {
                                                    root: styles.textFieldFormLabel,
                                                    focused: styles.textFieldFocused,
                                                },
                                            }}
                                            label={t('Registration.label_choose_initial_password')}
                                            name={'password'}
                                            type="password"
                                            value={ password }
                                            margin="normal"
                                            style={styles.textField}
                                            fullWidth={true}
                                            required
                                            error={pwError}
                                            helperText={password.length < 12 ? t('Registration.textfield_helpertext_password') : passwordHelperText}
                                            onChange={ e => this.handleChangeInput(e.target.name, e.target.value) }
                                        />
                                        <TextField
                                        InputProps={{
                                                classes: {
                                                    underline: styles.textFieldUnerline
                                                },
                                            }}
                                            InputLabelProps={{
                                                FormLabelClasses: {
                                                    root: styles.textFieldFormLabel,
                                                    focused: styles.textFieldFocused,
                                                },
                                            }}
                                            label={t('Registration.label_confirm_initial_password')}
                                            name={'repeatPassword'}
                                            type="password"
                                            value={repeatPassword}
                                            margin="normal"
                                            style={styles.textField}
                                            fullWidth={true}
                                            required
                                            error={pwError}
                                            helperText={repeatPWHelperText}
                                            onChange={ e => this.handleChangeInput(e.target.name, e.target.value) }
                                            onKeyUp={ this.handleSubmitEnter }
                                        />
                                    </Grid>
                                    <Grid container justifyContent="space-between" style={styles.buttonContainer}>
                                        <Grid item>
                                            <Link to="/" style={{ textDecoration: 'none' }}>
                                                <Button
                                                style={{color: theme.palette.primary.dark}}
                                                >
                                                <Trans i18nKey='Global.button_cancel'/>
                                                </Button>
                                            </Link>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                variant="outlined"
                                                style={{...styles.registerButton, color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark}}

                                                onClick={ () => this.handleSubmit() }
                                            >
                                                <Trans i18nKey='Registration.button_signup'/>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>)
                            }
                            {this.state.success && (
                                <div>
                                    <Grid container justifyContent="center" direction="column" alignItems="center">
                                        <Typography style={{ marginTop: 40, marginBottom: 40, fontSize: 14 }}>
                                        <Trans i18nKey='Registration.text_success'/>
                                        </Typography>
                                        <Grid item>
                                            <Button
                                                style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                                                // variant="outlined"
                                                onClick={this.backToLogin}
                                                // color="primary"
                                                >
                                                <Trans i18nKey='Registration.button_signin'/>
                                                </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            )}
                        </Grid>
                    </Paper>
                </Grid>
                <Grid container justifyContent="center">
                  <Grid item style={{ marginTop: 20 }}>
                    <Select
                      native
                      disableUnderline
                      variant='standard'
                      labelId={t('ChooseLanguage.button_choose_language')}
                      id="login_language_selectt"
                      value={this.state.language}
                      onChange={this.handleLanguageChange}
                      style={styles.selectLang}
                      sx={{color:"grey", fontSize:12}}
                    >
                      <option value='en'>English</option>
                      <option value='de'>Deutsch</option>
                    </Select>
                  </Grid>
                </Grid>
            </Container>
        )
    }
}

export default Registration
